<template>
    <div id="preloader">
        <div id="status">
            <div class="spinner">
                <div class="bounce1"></div>
                <div class="bounce2"></div>
                <div class="bounce3"></div>
            </div>
        </div>
    </div>
</template>

<script>

export default {}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Spinner.vue